<!--The content below is only a placeholder and can be replaced.-->
<!-- <div style="text-align:center">
    <main>
        <router-outlet></router-outlet>
    </main> -->

<div class="sg-app-container"  (scroll)="onWindowScroll($event);">
  <div id="sg-app-header" class="row mx-0" *ngIf="showHeaderFooter">
    <app-header class="col-12 px-0"
    ></app-header>
    <app-navigation class="col-12 d-block"></app-navigation>
  </div>
  <main class="sg-app-main">
    <router-outlet></router-outlet>
  </main>

  <app-footer id="sg-app-footer" class="row mx-0" *ngIf="showHeaderFooter"></app-footer>

</div>
<!-- <div class="sg-spinner" style="z-index: 99999;" *ngIf="displayBlankPage"></div> -->